import { defineStore } from 'pinia';
import config from './config';
export default defineStore('user', config);